"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _downshift = _interopRequireDefault(require("downshift"));

var _Paper = _interopRequireDefault(require("@eig-builder/core-ui/Paper"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _FormHelperText = _interopRequireDefault(require("@eig-builder/core-ui/FormHelperText"));

var _helpers = require("./helpers");

var _adornment = _interopRequireDefault(require("./components/adornment"));

var _renderInput = _interopRequireDefault(require("./components/render-input"));

var _renderSuggestion = _interopRequireDefault(require("./components/render-suggestion"));

var _renderSelectfieldOptions = _interopRequireDefault(require("./components/render-selectfield-options"));

require("./style.scss");

var _style2 = _interopRequireDefault(require("./style"));

var _views = require("./views");

// External Dependencies
// Core
// Helpers & Components
// Styling
// Component
var DownshiftAutocomplete = function DownshiftAutocomplete(props) {
  var mode = props.mode,
      multiSelect = props.multiSelect,
      ignoreFields = props.ignoreFields,
      dataElementSuffix = props.dataElementSuffix,
      label = props.label,
      onSelectionChange = props.onSelectionChange,
      placeholder = props.placeholder,
      selectedSuggestions = props.selectedSuggestions,
      suggestions = props.suggestions,
      dataToLabelsMapping = props.dataToLabelsMapping,
      handleOnAddNew = props.handleOnAddNew,
      customInputValidator = props.customInputValidator,
      itemToString = props.itemToString,
      prefix = props.prefix,
      Adornment = props.Adornment,
      ListItem = props.ListItem,
      validators = props.validators,
      validationError = props.validationError,
      handleOnBlur = props.handleOnBlur,
      noItemFoundText = props.noItemFoundText;

  var _React$useState = _react["default"].useState(''),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1];

  var showSelectBoxStyling = (!mode || mode !== 'inline') && !multiSelect;

  var handleKeyDown = function handleKeyDown(event) {
    if (selectedSuggestions.length && !inputValue.length && event.key === 'Backspace') {
      onSelectionChange(selectedSuggestions.slice(0, selectedSuggestions.length - 1));
    }
  };

  var handleInputChange = function handleInputChange(event) {
    setInputValue(event.target.value);

    if (!multiSelect) {
      onSelectionChange([]);
    }
  };

  var handleInputBlur = function handleInputBlur(event) {
    handleOnBlur();
  }; // Pass down default value


  (0, _react.useEffect)(function () {
    if (selectedSuggestions && selectedSuggestions.length === 1 && !multiSelect && inputValue === '') {
      var value = selectedSuggestions[0].label || selectedSuggestions[0].value;
      setInputValue(value);
    }
  }, [selectedSuggestions]); // Someone has clicked the inline item/chip to delete an item

  var handleDeleteItem = function handleDeleteItem(item) {
    var updatedSuggestions = selectedSuggestions.filter(function (suggestion) {
      return suggestion !== item;
    });
    onSelectionChange(updatedSuggestions);
  };

  var handleChange = function handleChange(item) {
    var isDuplicate = selectedSuggestions.indexOf(item) > -1; // Multi select options or default to a single option

    if (!isDuplicate && multiSelect) {
      var newSelectedItems = [].concat((0, _toConsumableArray2["default"])(selectedSuggestions), [item]);
      setInputValue('');
      onSelectionChange(newSelectedItems);
    } else if (!isDuplicate) {
      var _inputValue = item.label || item.value;

      setInputValue(_inputValue);
      onSelectionChange([item]);
    }
  };

  var handleFilteringItems = function handleFilteringItems(item) {
    // If item is already selected, do not show it again
    if (selectedSuggestions.indexOf(item) > -1) {
      return null;
    }

    return (0, _helpers.filterItems)(inputValue, ignoreFields, item);
  };

  var handleAddingNewItem = function handleAddingNewItem(newValue) {
    if (multiSelect) {
      handleOnAddNew(newValue);
      setInputValue('');
    } else {
      handleOnAddNew(newValue);
      setInputValue(newValue);
    }
  }; // Handle errors passed down by the property-editor


  var propertyEditorHasError = validators && validators[0] && validators[0].error_message && validators[0].error_message.length > 0;

  var ShowPropertyEditorError = function ShowPropertyEditorError() {
    if (propertyEditorHasError || validationError) {
      return _react["default"].createElement(_FormHelperText["default"], null, _react["default"].createElement(_views.ErrorWrapper, null, " ", validators[0].error_message, " "));
    }

    return null;
  }; // Build a list of filtered Suggestions


  var filteredSuggestions = suggestions.filter(function (item) {
    return handleFilteringItems(item);
  });
  var selectedSuggestionIndex = (0, _helpers.getSelectedSuggestionsIndex)(suggestions, selectedSuggestions);
  var defaultHighlightIndex = selectedSuggestionIndex !== -1 ? selectedSuggestionIndex : 0; // Render the component

  return _react["default"].createElement(_downshift["default"], {
    id: "downshift-multiple-test",
    inputValue: inputValue,
    itemToString: itemToString,
    onChange: handleChange,
    selectedItem: selectedSuggestions,
    defaultHighlightedIndex: defaultHighlightIndex
  }, function (_ref) {
    var getInputProps = _ref.getInputProps,
        getItemProps = _ref.getItemProps,
        getLabelProps = _ref.getLabelProps,
        isOpen = _ref.isOpen,
        openMenu = _ref.openMenu,
        selectedItem = _ref.selectedItem,
        highlightedIndex = _ref.highlightedIndex;
    // Events for the input field
    var getInputPropsObj = {
      onKeyDown: handleKeyDown,
      placeholder: placeholder,
      onFocus: openMenu,
      autocomplete: 'drop-down'
    };

    var _getInputProps = getInputProps(getInputPropsObj),
        _onBlur = _getInputProps.onBlur,
        _onChange = _getInputProps.onChange,
        onFocus = _getInputProps.onFocus,
        inputProps = (0, _objectWithoutProperties2["default"])(_getInputProps, ["onBlur", "onChange", "onFocus"]);

    var inputMatchesValue = suggestions.filter(function (item) {
      return (0, _helpers.matchItemValueToInput)(item, inputValue);
    });
    var inputMatchAddedAlready = selectedItem.filter(function (item) {
      return (0, _helpers.matchItemValueToInput)(item, inputValue);
    });
    var showAddNewButton = typeof handleOnAddNew === 'function' && inputValue && inputValue.length > 3 && inputMatchesValue.length === 0 && inputMatchAddedAlready.length === 0 && (customInputValidator && customInputValidator(inputValue) || !customInputValidator); // To show values before the input form, we show the Adornmnet component either passed or set as default.

    var AdornmentComponent = Adornment || _adornment["default"];

    var InputAdornment = _react["default"].createElement(AdornmentComponent, {
      selectedItem: selectedItem,
      handleDeleteItem: handleDeleteItem,
      prefix: prefix,
      itemToString: itemToString
    }); // Input options


    var inputLabelPropOptions = (0, _objectSpread2["default"])({}, getLabelProps(), {
      shrink: true
    });
    var inputPropOptions = {
      startAdornment: mode === 'inline' ? InputAdornment : null,
      onBlur: function onBlur(e) {
        handleInputBlur(e); // Passed down handler

        _onBlur(e); // Generated by Downshift

      },
      onChange: function onChange(event) {
        handleInputChange(event);

        _onChange(event);
      },
      onFocus: onFocus
    };
    var inputOptions = {
      fullWidth: true,
      label: label,
      InputLabelProps: inputLabelPropOptions,
      InputProps: inputPropOptions,
      inputProps: inputProps,
      error: propertyEditorHasError || validationError,
      dataElementSuffix: dataElementSuffix
    };
    return _react["default"].createElement("div", {
      className: "autocomplete-containing-wrapper"
    }, _react["default"].createElement(_views.AutoSuggestionWrapper, {
      selectboxstyling: showSelectBoxStyling,
      className: "autocomplete-wrapper ".concat(multiSelect ? '' : ' autocomplete-none-multi')
    }, (0, _renderInput["default"])(inputOptions), isOpen ? _react["default"].createElement(_views.SuggestionsWraper, {
      className: "autocomplete-suggestions-wrapper"
    }, _react["default"].createElement(_Paper["default"], {
      style: {
        maxHeight: '250px',
        overflow: 'hidden',
        overflowY: 'scroll'
      },
      square: true
    }, filteredSuggestions.map(function (suggestion, index) {
      var props = {
        suggestion: suggestion,
        index: index,
        itemProps: getItemProps({
          item: suggestion
        }),
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        dataToLabelsMapping: dataToLabelsMapping,
        dataElementSuffix: dataElementSuffix // See if the developer passed their own list item to use.

      };

      if (ListItem) {
        return _react["default"].createElement(ListItem, props);
      } // Else we resort to default


      return (0, _renderSuggestion["default"])(props);
    }), filteredSuggestions.length === 0 && noItemFoundText && !showAddNewButton ? ListItem ? _react["default"].createElement(ListItem, {
      suggestion: null,
      noItemFoundText: noItemFoundText
    }) : (0, _renderSuggestion["default"])({
      suggestion: null,
      noItemFoundText: noItemFoundText
    }) : null, showAddNewButton ? _react["default"].createElement(_Button["default"], {
      fullWidth: true,
      variant: "contained",
      color: "secondary",
      onClick: function onClick() {
        return handleAddingNewItem(inputValue);
      }
    }, "+ ", inputValue) : '')) : null, showSelectBoxStyling && _react["default"].createElement(_renderSelectfieldOptions["default"], {
      isOpen: isOpen
    }), _react["default"].createElement(ShowPropertyEditorError, null)));
  });
};

DownshiftAutocomplete.propTypes = {
  dataElementSuffix: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  onSelectionChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  selectedSuggestions: _propTypes["default"].array,
  suggestions: _propTypes["default"].array.isRequired,
  dataToLabelsMapping: _propTypes["default"].object.isRequired,
  itemToString: _propTypes["default"].func.isRequired,
  prefix: _propTypes["default"].node,
  mode: _propTypes["default"].string,
  handleOnAddNew: _propTypes["default"].func,
  multiSelect: _propTypes["default"].bool,
  ignoreFields: _propTypes["default"].array,
  customInputValidator: _propTypes["default"].func,
  Adornment: _propTypes["default"].any,
  ListItem: _propTypes["default"].any,
  validators: _propTypes["default"].array,
  validationError: _propTypes["default"].any,
  handleOnBlur: _propTypes["default"].func,
  noItemFoundText: _propTypes["default"].string
};

var _default = (0, _styles.withStyles)(_style2["default"])(DownshiftAutocomplete);

exports["default"] = _default;